import React from "react";
import { Link } from "react-router-dom";

const Subheader = ({ title, href }) => {
  return (
    <div className="bg-theme py-7 mt-5">
      <div className="container mx-auto lg:px-8 px-4">
        <div
          className={`flex items-center ${href ? "justify-between" : "justify-center"} md:flex-row flex-col gap-5`}>
          <div className={`md:block hidden ${href && 'lg:basis-1/3'}`}></div>
          <div className={` ${href && 'basis-1/3'} `}>
            <h1 className="md:text-4xl text-2xl font-bold text-white">
              {title}
            </h1>
          </div>
          {href && (
            <div>
              <Link
                to={href}
                className="md:py-2.5 py-1.5 md:px-16 px-8 border border-transparent rounded-full text-sm font-medium text-theme bg-white cursor-pointer"
              >
                Tilføj ny opgave
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Subheader;
